import { orgCalendarDate } from '@/lib/utils/custom-date/custom-date';
import { getOrganizationTimeZone } from '@/lib/utils/custom-date/org-time-zone';
import { attendanceDateRangeClause } from '@/modules/attendance/hr-my-attendance/services/attendance-rules';

// `TimeSheet.TaskDate` is date only: the picked day at 00:00:00 UTC, read by its date part and never
// shifted to a time zone. "Today" and the default ranges are days in the organization's time zone.

const DAY = /^(\d{4})-(\d{2})-(\d{2})$/;

const shiftMonth = (day: string, months: number, dayOfMonth: number): string => {
  const [, year, month] = DAY.exec(day) ?? [];
  return new Date(Date.UTC(Number(year), Number(month) - 1 + months, dayOfMonth))
    .toISOString()
    .slice(0, 10);
};

/** Today ("YYYY-MM-DD") in the organization's time zone. */
export const orgToday = (
  now: Date = new Date(),
  timeZone: string = getOrganizationTimeZone()
): string => orgCalendarDate(now.toISOString(), timeZone);

/** The first day of the month `day` ("YYYY-MM-DD") falls in. */
export const startOfMonthDay = (day: string): string => shiftMonth(day, 0, 1);

/** The first day of the month before the one `day` falls in. */
export const startOfPreviousMonthDay = (day: string): string => shiftMonth(day, -1, 1);

/** The last day of the month before the one `day` falls in. */
export const endOfPreviousMonthDay = (day: string): string => shiftMonth(day, 0, 0);

/** A `where` clause for `TaskDate`s from day `from` to day `to` (both inclusive, either optional). */
export const taskDateRangeClause = (from?: string, to?: string) =>
  attendanceDateRangeClause(from, to);
